import { TierIIReportKind } from "encamp-prisma/generated/browser";

/**
 * An annual report for the current reporting year, signed before January 1 of the
 * next year. `todayIsoDate` is a `YYYY-MM-DD` calendar date in the caller's zone.
 */
export function isEarlyAnnualTierIIReport(
  report: { reportKind?: string | null; reportingYear?: number | null },
  todayIsoDate: string,
  currentReportingYear: number
): boolean {
  return (
    report.reportKind === TierIIReportKind.ANNUAL &&
    report.reportingYear === currentReportingYear &&
    todayIsoDate < `${currentReportingYear + 1}-01-01`
  );
}
